import axios from "axios";

const API_BASE_URL = "/auth";

const getCurrentLocale = () => {
  if (typeof window === "undefined") return "en";

  const storedLocale =
    window.localStorage?.getItem("thetavern.locale") ||
    document.documentElement.lang ||
    navigator.language ||
    "en";

  const locale = storedLocale.split(/[-_]/)[0] || "en";

  return ["en", "fr"].includes(locale) ? locale : "en";
};

const withLocale = (payload = {}) => ({
  ...payload,
  locale: getCurrentLocale(),
});

const normalizeIdentifier = (value) =>
  typeof value === "string" ? value.trim() : value;

const localeConfig = () => ({
  headers: {
    "X-Tavern-Locale": getCurrentLocale(),
  },
});

export async function login(username, password) {
  const response = await axios.post(
    `${API_BASE_URL}/login`,
    withLocale({
      username: normalizeIdentifier(username),
      password,
    }),
    localeConfig()
  );

  return response.data; // { token: "..." }
}

export async function register({
  acceptLegalTerms,
  captchaToken,
  email,
  password,
  returnTo,
  username,
}) {
  const response = await axios.post(
    `${API_BASE_URL}/register`,
    withLocale({
      acceptLegalTerms,
      captchaToken,
      email: normalizeIdentifier(email),
      password,
      ...(returnTo ? { returnTo } : {}),
      username: normalizeIdentifier(username),
    }),
    localeConfig()
  );

  return response.data;
}

export async function fetchCaptchaConfig() {
  const response = await axios.get(`${API_BASE_URL}/captcha/config`, localeConfig());

  return response.data;
}

export async function verifyEmail(token) {
  const response = await axios.post(
    `${API_BASE_URL}/verify-email`,
    withLocale({
      token,
    }),
    localeConfig()
  );

  return response.data;
}

export async function resendVerification(identifier, returnTo) {
  const response = await axios.post(
    `${API_BASE_URL}/resend-verification`,
    withLocale({
      identifier: normalizeIdentifier(identifier),
      ...(returnTo ? { returnTo } : {}),
    }),
    localeConfig()
  );

  return response.data;
}

export async function requestPasswordReset(identifier) {
  const response = await axios.post(
    `${API_BASE_URL}/forgot-password`,
    withLocale({
      identifier: normalizeIdentifier(identifier),
    }),
    localeConfig()
  );

  return response.data;
}

export async function validateResetToken(token) {
  const response = await axios.get(`${API_BASE_URL}/reset-password/validate`, {
    params: { token, locale: getCurrentLocale() },
    ...localeConfig(),
  });

  return response.data;
}

export async function resetPassword({ password, token }) {
  const response = await axios.post(
    `${API_BASE_URL}/reset-password`,
    withLocale({
      password,
      token,
    }),
    localeConfig()
  );

  return response.data;
}

export async function fetchOAuthProviders() {
  const response = await axios.get(`${API_BASE_URL}/oauth/providers`, localeConfig());

  return response.data;
}

export function oauthStartUrl(provider, returnTo = "/dashboard") {
  return `${API_BASE_URL}/oauth/${provider}/start?returnTo=${encodeURIComponent(returnTo)}`;
}
